<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_loan_charges'] == 1 && userData.permissions['view_loans'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-end mb-2">
              <b-button v-show="userData.permissions['new_loan_charges'] == 1" v-b-modal.new-loancharge
                variant="primary" type="button" class="btn-sm btn"> <i class="mdi mdi-plus"></i> New Charge</b-button>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>No Data Found</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(charge)="data">
                  <b class="text-info">{{ commas(data.item.charge) }}</b>
                </template>
                <template #cell(percentage)="data">
                  <b class="text-info">{{ commas(data.item.percentage) }}%</b>
                </template>
                <template #cell(range_from)="data">
                  {{ commas(data.item.range_from) }}
                </template>
                <template #cell(range_to)="data">
                  {{ commas(data.item.range_to) }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby.username }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button v-show="userData.permissions['edit_loan_charges'] == 1"
                      @click="edit(data.item.id, data.item.range_from, data.item.range_to, data.item.charge, data.item.percentage)"
                      type="button" class="btn-sm btn" variant="info" v-b-modal.edit> <i
                        class="mdi mdi-square-edit-outline"></i> </b-button>
                    <b-button v-show="userData.permissions['delete_loan_charges'] == 1"
                      @click="remove(data.item.id, data.item.range_from, data.item.range_to, data.item.percentage)"
                      type="button" class="btn-sm btn" variant="danger" v-b-modal.delete> <i
                        class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Loan Charges</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-loancharge" centered title="New Loan Charge" title-class="font-14" hide-footer>
      <form @submit.prevent="addLoanCharge">
        <div class="form-group mb-2">
          <input v-model="id" type="hidden">
          <label>Range From</label>
          <input v-model="range_from" required type="number" class="form-control" />
          <label>Range To</label>
          <input v-model="range_to" required type="number" class="form-control" />
          <label>{{ userData.settings.loan_charges == 'flat' ? 'Charge' : 'Percentage' }}</label>
          <input v-if="userData.settings.loan_charges == 'flat'" v-model="charge" required type="number"
            class="form-control" />
          <input v-else v-model="percentage" required type="number" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-loancharge')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="edit-loancharge" centered title="Edit Loan Charge" title-class="font-14" hide-footer>
      <form @submit.prevent="editLoanCharge">
        <div class="form-group mb-2">
          <input v-model="id" type="hidden">
          <label>Range From</label>
          <input v-model="range_from" type="number" class="form-control" />
          <label>Range To</label>
          <input v-model="range_to" type="number" class="form-control" />
          <label>{{ userData.settings.loan_charges == 'flat' ? 'Charge' : 'Percentage' }}</label>
          <input v-if="userData.settings.loan_charges == 'flat'" v-model="charge" required type="number"
            class="form-control" />
          <input v-else v-model="percentage" required type="number" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('edit-loancharge')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-loancharge" centered title="Delete Loan Charge" title-class="font-18" hide-footer>
      <form @submit.prevent="removeLoanCharge">
        <input v-model="id" type="hidden">
        <span v-if="userData.settings.loan_charges == 'flat'">Are you sure you want to delete the Loan Charge : <b>{{
            range_from }}</b> - <b>{{ range_to }}</b> ?</span>
        <span v-else>Are you sure you want to delete the Loan Charge : <b>{{ percentage }}%</b> charge?</span>
        <br><br>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-loancharge')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { loanchargeMethods, loanchargeComputed } from "@/state/helpers";

export default {
  page: {
    title: "Loan Charges",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Loan Charges",
      items: [{ text: "Dashboard", to: "/", }, { text: "Loan Charges", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'range_from', label: 'From', visible: true },
        { key: 'range_to', label: 'To', visible: true },
        { key: 'charge', label: 'Charge', visible: JSON.parse(localStorage.getItem("user")).settings.loan_charges == 'flat' },
        { key: 'percentage', label: 'Percentage', visible: JSON.parse(localStorage.getItem("user")).settings.loan_charges == 'percentage' },
        { key: 'addedby', label: 'Added By', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],
      id: '',
      range_from: '',
      range_to: '',
      charge: '',
      percentage: ''
    };
  },
  computed: {
    ...loanchargeComputed,
    List() { return this.loancharges.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.loancharges.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.loancharges.length > 0) { a = false; } else { a = true; } return a },
  },
  mounted() {
    this.fetchLoanCharges();
    this.TotalRows = this.loancharges.length;
    this.isBusy = false;
  },
  methods: {
    ...loanchargeMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    edit(id, range_from, range_to, charge, percentage) {
      this.id = id;
      this.range_from = range_from;
      this.range_to = range_to;
      this.charge = charge;
      this.percentage = percentage;
      this.$bvModal.show('edit-loancharge')
    },

    remove(id, range_from, range_to, percentage) {
      this.id = id;
      this.range_from = range_from;
      this.range_to = range_to;
      this.percentage = percentage;
      this.$bvModal.show('delete-loancharge')
    },
    async addLoanCharge() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("range_from", this.range_from);
      formData.append("range_to", this.range_to);
      formData.append("charge", this.charge);
      formData.append("percentage", this.percentage)
      let url = "/addloancharge";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanCharges();
          this.$bvModal.hide('new-loancharge');
          this.range_from = "";
          this.range_to = "";
          this.charge = "";
          this.percentage = "";
          this.$toast.info("New Loan Charges Added");
        }
      });
    },
    async editLoanCharge() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("range_from", this.range_from);
      formData.append("range_to", this.range_to);
      formData.append("charge", this.charge);
      formData.append("percentage", this.percentage);
      let url = "/updateloancharge";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanCharges();
          this.$bvModal.hide('edit-loancharge');
          this.range_from = "";
          this.range_to = "";
          this.charge = "";
          this.percentage = "";
        }
      });
    },
    async removeLoanCharge() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeloancharge";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanCharges();
          this.$bvModal.hide('delete-loancharge');
        }
      });
    },
    FilterData() {
      this.filterLoanCharges({ datefrom: this.date_from, dateto: this.date_to });
    },
  },
};
</script>